// extracted by mini-css-extract-plugin
module.exports = {"CoverSectionEU":"CoverSectionEU_CoverSectionEU__vWDiE"};